export default "__VITE_ASSET__93fade02__"